import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ImpersonateService {
  constructor(private userService: UserService, private apiService: ApiService) {}

  async getToken(email: string, activateLogs = false): Promise<void> {
    const token = await this.userService.getImpersonateToken(email, activateLogs).toPromise();
    const accessToken = token.token;
    window.location.href = this.apiService.getVerticalURL(token.backofficeRedirectUrl)
      .toString() + '?token=' + accessToken;
  }
}
